import $ from './jquery-global';

const inputSelector = 'input.form-control, textarea.form-control';

// I controlli specializzati hanno componenti propri in Bootstrap Italia 2.13.4.
const excludedSelector = [
	'[type="hidden"]',
	'[type="checkbox"]',
	'[type="radio"]',
	'[type="time"]',
	'input[type="password"][data-bs-input]',
	'input.input-password[data-bs-input]',
	'input[type="search"][data-bs-autocomplete]'
].join(',');

export function initForm(container = document) {
	const $container = $(container);
	const $inputs = $container
		.find(inputSelector)
		.add($container.filter(inputSelector))
		.filter(function () { return !!this.closest('.contact-form'); })
		.not(excludedSelector);

	if (!$inputs.length) return;

	const Input = window.bootstrap && window.bootstrap.Input;
	if (!Input || typeof Input.getOrCreateInstance !== 'function') {
		console.error('initForm: bootstrap.Input non disponibile. Verificare il caricamento del bundle Bootstrap Italia.');
		return;
	}

	$inputs.each(function () {
		// Replica l'esclusione dei numerici con pulsanti del bundle allegato.
		if (this.type === 'number' &&
			this.parentElement.querySelector('button[class^="input-number-"]')) {
			return;
		}

		// "this" e' il nodo DOM nativo, non un oggetto jQuery.
		Input.getOrCreateInstance(this);
	});
}
